module.exports = __webpack_public_path__ + "static/media/loader.ab22e79e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/loader.svg
// module id = 1593
// module chunks = 0